mutation ConfirmImageEdit($input: ConfirmImageEditInput!) {
  confirmImageEdit(input: $input) {
    ... on GeneratedImage {
      id
      url
      originalImageUrl
      history {
        id
        type
        timestamp
        userId
        __typename
      }
      companyId
      modelName
      topicId
      __typename
    }
    ... on UserImage {
      id
      url
      originalImageUrl
      history {
        id
        type
        timestamp
        userId
        __typename
      }
      companyId
      topicId
      __typename
    }
    ... on StockImage {
      id
      url
      originalImageUrl
      history {
        id
        type
        timestamp
        userId
        __typename
      }
      companyId
      license
      provider
      externalId
      __typename
    }
    ... on StockPhoto {
      id
      url
      originalImageUrl
      history {
        id
        type
        timestamp
        userId
        __typename
      }
      companyId
      license
      provider
      externalId
      __typename
    }
    __typename
  }
}
